import React                           from 'react';
import { Prompt }                           from 'react-router-dom';
import { Observe }                          from 'rewire-core';
import { WithStyle, withStyles }            from 'rewire-ui';
import Typography                           from '@material-ui/core/Typography';
import { Theme }                            from '@material-ui/core/styles';
import TimecardTestEditTimecardsDailyRollup from './TimecardTestEditTimecardsDailyRollup';
import TimecardTestDailyTimecardView        from './TimecardTestDailyTimecardView';
import TimecardTestOtherPaymentsView        from './TimecardTestOtherPaymentsView';
import timecardTestEditTimecardsModel       from './TimecardTestEditTimecardsModel';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative'
  },
  title: {
    marginBottom: '15px',
  },
  scrollablePart: {
    overflow: 'auto'
  },
  employeeTitle: {
    marginBottom: '2px',
  },
});

interface ITimecardTestEditTimecardsViewProps {
  className?: string;
}

type TimecardTestEditTimecardsViewProps = WithStyle<ReturnType<typeof styles>, ITimecardTestEditTimecardsViewProps>;

class TimecardTestEditTimecardsView extends React.PureComponent<TimecardTestEditTimecardsViewProps> {
  constructor(props: TimecardTestEditTimecardsViewProps) {
    super(props);
  }

  componentDidMount() {
    timecardTestEditTimecardsModel.startMonitoringTimecardChanges();
  }

  componentWillUnmount() {
    timecardTestEditTimecardsModel.stopMonitoringTimecardChanges();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe render={() => {
          const employee = timecardTestEditTimecardsModel.selectedEmployee?.name;
          return <Prompt when={timecardTestEditTimecardsModel.hasChanges} message={(_) => `There are unsaved changes for ${employee}.\nDo you wish to return and save your changes?`} />;
        }} />

        <Observe render={() => (
          < >
            <div className={classes.title}>
              <Typography variant='h4' className={classes.employeeTitle}>{timecardTestEditTimecardsModel.selectedEmployee?.name}</Typography>
            </div>
            <div className={classes.scrollablePart}>
              <TimecardTestEditTimecardsDailyRollup />
              <TimecardTestDailyTimecardView />
              <TimecardTestOtherPaymentsView />
            </div>
          </>
        )} />
      </div>
    );
  }
}

export default withStyles<ITimecardTestEditTimecardsViewProps, unknown>(styles, TimecardTestEditTimecardsView);
